/**
 * Kollectin SSO JavaScript Functions
 */

// 登入表單驗證和提交
function login() {
    $("#emailError, #passwordError, #respError").hide();
    let email = $("#emailInput").val().trim();
    let password = $("#passwordInput").val().trim();
    var emailPattern = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (!emailPattern.test(email)) {
        $("#emailError").show();
        return;
    }
    if (password && password.length < 3) {
        $("#passwordError").show();
        return;
    }

    $.ajax({
        url: '/login',
        type: 'POST',
        data: {
            email: email,
            password: password,
            returnUrl: $('input[name="returnUrl"]').val(),
            __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val()
        },
        success: function (response) {
            if (response.success) {
                console.log(response);
                window.location.href = response.returnUrl + "&code=" + response.code;
            } else {
                $("#respError").text(response.message).show();
            }
        },
        error: function (xhr, status, error) {
            if (xhr.status === 400) {
                $("#respError").text("Data validation failed. Please try again.").show();
            } else {
                $("#respError").text("An error occurred. Please try again later.").show();
            }
        }
    });
}

function loginToAdmin() {
    $("#passwordError, #respError").hide();
    let account = $("#accountInput").val().trim();
    let password = $("#passwordInput").val().trim();
    
    // 輸入驗證
    if (!account || account.length < 3) {
        $("#respError").text("Please enter a valid account.").show();
        return;
    }
    
    if (!password || password.length < 3) {
        $("#passwordError").show();
        return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const redirect_url = urlParams.get('redirect_url');

    // 防止XSS：過濾輸入值中的特殊字符
    account = account.replace(/[<>&'"]/g, '');

    // 獲取CSRF令牌
    const token = $('input[name="__RequestVerificationToken"]').val();
    
    $.ajax({
        url: '/admin/login' + (redirect_url ? '?redirect_url=' + encodeURIComponent(redirect_url) : ''),
        type: 'POST',
        headers: {
            'RequestVerificationToken': token
        },
        data: {
            account: account,
            password: password,
            __RequestVerificationToken: token
        },
        success: function (response) {
            if (response.success) {
                // 防止重放攻擊：登入成功後立即使用token
                localStorage.setItem('lastLoginTime', Date.now());
                
                // 登入成功後直接導向到返回的URL
                window.location.href = response.returnUrl;
            } else {
                $("#respError").text(response.message).show();
                
                // 錯誤計數，防止暴力破解
                incrementLoginFailCount();
            }
        },
        error: function (xhr, status, error) {
            if (xhr.status === 400) {
                $("#respError").text("Data validation failed. Please try again.").show();
            } else {
                $("#respError").text("An error occurred during login. Please try again later.").show();
            }
            // 錯誤計數，防止暴力破解
            incrementLoginFailCount();
        }
    });
}

// 防止暴力破解的登入失敗計數器
function incrementLoginFailCount() {
    const key = 'loginFailCount';
    const count = parseInt(localStorage.getItem(key) || '0') + 1;
    localStorage.setItem(key, count);
    
    // 如果失敗超過5次，延遲提交
    if (count >= 5) {
        const delaySeconds = Math.min(30, Math.pow(2, count - 5)); // 指數延遲
        $("#loginBtn").prop('disabled', true);
        setTimeout(function() {
            $("#loginBtn").prop('disabled', false);
            $("#respError").text("Please try again later...").show();
        }, delaySeconds * 1000);
    }
    
    // 24小時後重置計數
    if (count === 1) {
        setTimeout(function() {
            localStorage.removeItem(key);
        }, 24 * 60 * 60 * 1000);
    }
}

// 忘記密碼功能
function forgotPassword() {
    $("#emailError, #respError").hide();
    let email = $("#emailInput").val().trim();
    var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (!emailPattern.test(email)) {
        $("#emailError").show();
        return;
    }

    $.ajax({
        url: '/forgot_password',
        type: 'POST',
        data: { 
            email: email,
            __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val()
        },
        success: function(response) {
            if (response.success) {
                $("#divSubmit").hide();
                $("#divReset").show();
            } else {
                $("#respError").text(response.message).show();
            }
        },
        error: function() {
            $("#respError").text("An error occurred. Please try again later.").show();
        }
    });
}

// 重設密碼功能
function updatePassword() {
    let password1 = $("#password1Input").val().trim();
    let password2 = $("#password2Input").val().trim();
    $("#password1Error, #password2Error").text("");
    $("#password1Error, #password2Error").show();
    
    // 密碼複雜度檢查
    if (password1.length < 8) {
        $("#password1Error").text(`Please set a valid password (8-20 characters, no spaces)`);
        return;
    }
    
    // 檢查密碼強度
    if (!/[A-Z]/.test(password1) || !/[a-z]/.test(password1) || !/[0-9]/.test(password1)) {
        $("#password1Error").text(`Password must contain uppercase, lowercase letters and numbers`);
        return;
    }
    
    if (password2 != password1) {
        $("#password2Error").text(`The passwords you entered do not match`);
        return;
    }
    
    let token = $('#token').val();

    $.ajax({
        url: `/reset_password`,
        type: "POST",
        data: {
            token: token,
            newPassword: password1,
            __RequestVerificationToken: $('input[name="__RequestVerificationToken"]').val()
        },
        success: function (response) {
            if (response.success) {
                $("#resetDoneBox").show();
                $("#resetBox").hide();
            } else {
                $("#respError").text(response.message).show();
            }
        },
        error: function (xhr, status, error) {
            $("#respError").text("An error occurred. Please try again later.").show();
        },
    });
}
